import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import {
  ActionPerformed,
  PushNotificationSchema,
  PushNotifications,
  Token,
} from '@capacitor/push-notifications';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class FcmService {
title:any
  constructor(public service:ApiService,public router:Router) { }
  initPush() {
    //('Initializing HomePage');
    PushNotifications.requestPermissions().then(result => {
      // console.log(result)
      if (result.receive === 'granted') {
        // Register with Apple / Google to receive push via APNS/FCM
        PushNotifications.register();
      } else {
        // Show some error
      }
    });

    PushNotifications.addListener('registration', (token: Token) => {
      // console.log('Push registration success, token: ' + token.value);
      this.service.set_device_token(token.value)
      window.localStorage.setItem('token',token.value)
    });

    PushNotifications.addListener('registrationError', (error: any) => {
      // console.log('Error on registration: ' + JSON.stringify(error));
    });

    PushNotifications.addListener(
      'pushNotificationReceived',
      (notification: PushNotificationSchema) => {
        // console.log('Push received: ' + JSON.stringify(notification));/
      },

    );

    PushNotifications.addListener(
      'pushNotificationActionPerformed',
      (notification: ActionPerformed) => {
        // console.log(JSON.stringify(notification))
        let data = notification.notification.data
        // console.log(data)
       let title = data.title
      //  console.log(title)
        if(title == 'New Message Received'){
          this.router.navigate(['chat-list'])
        }else if(title == 'ad in review' || title == 'ad approved'){
          this.router.navigate(['my-ads'])
        }else if(title == 'Ad Not approved'){
          this.router.navigate(['tabs/my-ads'])
        }else if(title == 'payment confirmed'){
          this.router.navigate(['order-list'])
        }else if(title == 'order delivered'){
          this.router.navigate(['order-list'])
        }else if(title == 'New Order'){
          this.router.navigate(['order-recieved'])
        }else if(title == 'order received'){
          this.router.navigate(['order-recieved'])
        }else if(title == 'order completed'){
          this.router.navigate(['order-recieved'])
        }else if(title == 'order on way'){
          this.router.navigate(['cart-history'])
        }else{}
        
        
        // alert('Push action performed: ' + JSON.stringify(notification));
      },
    );
  }
}
